<!--
  +---------------------------------------------------------------------------------------
  | @Copyright: Frippler Copyright (c)
  | @Title:     工序工时标定
  +---------------------------------------------------------------------------------------
-->

<template>
  <div class="pp-process header-padding">
    <f-page-header />

    <div class="filter-container">
      <div class="filter-box">
        <span class="filter-item sm">
          <qc-scheme-selector v-model="query.schemeid" placeholder="选择质检方案" @change="fetchData(1)" />
        </span>

        <span class="filter-item sm">
          <f-search-input v-model="query.keyword" @change="fetchData(1)" />
        </span>
      </div>

      <div class="toolbox">
        <el-button type="success" icon="el-icon-plus" @click="edit()">新建工序</el-button>
        <el-button type="success" icon="el-icon-folder-add" plain @click="importShow = true">导入</el-button>
      </div>
    </div>

    <el-card v-loading="loading" class="table-card" shadow="never">
      <el-table ref="listTable" :data="list" size="medium" class="padding-small" style="width: 100%" @selection-change="handleSelectionChange">
        <el-table-column type="selection" width="60" />
        <el-table-column label="工序编号" min-width="120" show-overflow-tooltip>
          <template slot-scope="scope">
            <span>{{ scope.row.process_no }}</span>
          </template>
        </el-table-column>

        <el-table-column label="工序内容" min-width="160" show-overflow-tooltip>
          <template slot-scope="scope">
            <span>{{ scope.row.process_title }}</span>
          </template>
        </el-table-column>

        <el-table-column label="额定工时" min-width="100" align="right">
          <template slot-scope="scope">
            <span class="font-16 number text-bold">{{ scope.row.standard_hour }} </span>
            <span class="font-13 text-muted">{{ scope.row.standard_unit }}/件</span>
          </template>
        </el-table-column>

        <el-table-column label="附加工时" min-width="100" align="right">
          <template slot-scope="scope">
            <span class="font-16 number text-bold">{{ scope.row.add_hour }} </span>
            <span class="font-13 text-muted">{{ scope.row.standard_unit }}</span>
          </template>
        </el-table-column>
        <el-table-column width="20" />
        <el-table-column label="质检方案" min-width="140" show-overflow-tooltip>
          <template slot-scope="scope">
            <span >{{ scope.row.scheme_title }}</span>
          </template>
        </el-table-column>

        <el-table-column label="备注" min-width="160" show-overflow-tooltip>
          <template slot-scope="scope">
            <span>{{ scope.row.remark }}</span>
          </template>
        </el-table-column>

        <el-table-column label="操作" align="right" width="120">
          <template slot-scope="scope">
            <el-button type="text" @click="edit(scope.row)">编辑</el-button>
            <el-button type="text" @click="deleteOne(scope.row)">删除</el-button>
          </template>
        </el-table-column>
        <template slot="empty">
          <img class="image huger mt-lg" src="@/assets/empty.png">
          <div class="font-md mb-hg">暂无数据</div>
        </template>
      </el-table>
    </el-card>

    <f-table-footer checkbox :list="list" :selection="multiSelection" @toggle="toggleAll" :total="total" :pindex.sync="query.pindex" :psize.sync="query.psize" @change="fetchData">
      <template slot="left">
        <el-button plain :disabled="multiSelection.length === 0" size="mini" @click="deleteMulti">删除</el-button>
        <el-button class="ml-lg" plain :disabled="total === 0" size="mini" @click="exportProcess">导出</el-button>
      </template>
    </f-table-footer>

    <pp-process-import v-if="importShow" :show.sync="importShow" @submit="fetchData(1)" />

    <new-process v-if="editShow" :show.sync="editShow" :processid="activeProcessid" @success="fetchData(1)" />
  </div>
</template>

<script>
import { getProcessListApi, processDelApi, exportProcessApi } from '@/api/pp/processApi'

export default {
  name: 'PpProcess',

  components: {
    QcSchemeSelector: () => import('@/views/qc/components/QcSchemeSelector'),
    PpProcessImport: () => import('@/views/pp/components/PpProcessImport'),
    NewProcess: () => import('@/views/pp/components/NewProcess'),
  },

  data() {
    return {
      activeProcessid: null,
      editShow: false,
      importShow: false,
      query: {
        keyword: '',
        schemeid: null,
        pindex: 1,
        psize: this.$store.state.commonStore.psize,
      },
      list: [],
      multiSelection: [],
      total: 0,
      loading: false
    }
  },

  computed: {
    allQcSchemesObj() {
      return this.$store.getters.allQcSchemesObj
    }
  },

  created() {
    this.fetchData(1)
  },

  methods: {
    fetchData (page, loading = true) {
      if (page) this.query.pindex = page
      if (loading) this.loading = true
      getProcessListApi(this.query).then(res => {
        this.loading = false
        if (!res.errno) {
          this.list = res.data.list
          this.total = res.data.total
        }
      })
    },

    handleSelectionChange(val) {
      this.multiSelection = val
    },

    toggleAll() {
      this.$refs.listTable.toggleAllSelection()
    },
    edit(row) {
      this.activeProcessid = row ? row.processid : null
      this.editShow = true
    },

    deleteOne(item) {
      this.$confirm(`即将删除工序<span class="text-primary"> ${item.process_no}</span>，是否继续 ？`, '提示', {
        dangerouslyUseHTMLString: true,
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.loading = true
        processDelApi({ processids: [item.processid] }).then(res => {
          this.loading = false
          if (!res.errno) {
            this.$message.success('工序删除成功！')
            this.fetchData()
          } else {
            this.$message.error(res.message)
          }
        })
      }).catch(() => { });
    },

    deleteMulti() {
      let tmp = this.multiSelection.map(v => v.processid)
      this.$confirm(`即将删除<span class="text-primary"> ${tmp.length}</span> 个工序，是否继续 ？`, '提示', {
        dangerouslyUseHTMLString: true,
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.loading = true
        processDelApi({ processids: tmp }).then(res => {
          this.loading = false
          if (!res.errno) {
            this.$message.success('工序删除成功！')
            this.fetchData()
          } else {
            this.$message.error(res.message)
          }
        })
      }).catch(() => { });
    },

    exportProcess() {
      exportProcessApi(this.query).then(res => {
        if (!res.errno) {
          window.open(res.data.url)
          this.$message.success('工序导出成功！')
        }
      })
    },
  }
}
</script>

<style lang="scss" scoped>
.pp-process {
  position: relative;
}
</style>
